<template>
    <div class="kt-grid kt-grid--ver kt-grid--root kt-page">
        <div class="kt-grid__item   kt-grid__item--fluid kt-grid  kt-grid kt-grid--hor kt-login-v2" id="k_login_v2">

            <div class="kt-grid__item">
                <div class="kt-login-v2__head">
                    <div class="kt-login-v2__head-logo">
                        <a :href="$route('dashboard')">
                            <img width="128px" src="svg/youbuyda.svg" alt="youbuyda"/>
                        </a>
                    </div>
                </div>
            </div>
            <div class="mx-auto">

                <div class="mt-5 py-5">
                    <h1>Ihr Laden?</h1>
                    <div class="kt-separator kt-separator--space-lg kt-separator--border-dashed"></div>
                </div>

                <p class="lead font-weight-bold">
                    Sie möchten für folgendes Geschäft die Inhaberschaft
                    beantragen:
                </p>

                <section class="my-5 py-5">
                    <div class="card p-3 d-inline-block">
                        <blockquote class="blockquote mb-0 card-body">
                            <address class="my-0">
                                <strong>{{ store.attributes.name }}</strong>
                                <br>{{ store.attributes.address.street1 }}

                                <br v-if="store.attributes.address.street2">{{ store.attributes.address.street2 ? store.attributes.address.street2 : "" }}

                                <br>{{ store.attributes.address.postcode }}, {{ store.attributes.address.city }}
                            </address>
                        </blockquote>
                    </div>
                </section>

                <div class="mt-5">
                    <p class="lead">
                        Fast geschafft!<br>
                        Um nun die Verifizierung abzuschließen, tragen Sie ihre Telefonnummer in das unten stehende Feld
                        ein. Einer unserer Mitarbeiter wird Sie nach erfolgreicher Registrierung kontaktieren.
                    </p>
                </div>

                <section class="my-5 py-5">
                    <form style="max-width: 800px;">
                        <div class="form-group ">
                            <label>{{ __('user.provide_phone_number') }}</label>
                            <div class="input-group">
                                <input type="text"
                                       class="form-control form-control-lg"
                                       v-model="form.user_phone"
                                       :placeholder="__('user.phone_placeholder')" required>
                                <div class="input-group-append">
                                    <button class="btn btn-primary" @click="submit">
                                        {{ __('auth.proceed') }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: {
        store: Object,
    },
    data() {
        return {
            form: this.$inertia.form({
                user_phone: '',
                store_uudis: [this.store.id]
            })
        }
    },
    methods: {
        submit() {
            this.form.post(this.$route('store-verification-request'));
        }
    },
}
</script>
